import { dynamicConfig } from "../../statsig/gates";
import { Statsig } from "../../statsig/StatsigProvider";
import { QUALITY_MODE_NUMBER_MAP } from "./constants";
import { QualityMode } from "./room/participant/media/types";
import { BackgroundSettings } from "./types";
import { getStoredAudioVideoSettings } from "./utils";

export const MAX_ROOM_DURATION_SECONDS = 60 * 60 * 3; // 3 hours
export const DEFAULT_DEVICE_ID = "default";

/**
 * Returns a number greater than 0 if a is greater than b, a number less than 0
 * if b is greater than a, or 0 if they are equal.
 */
export function compareQualityMode(a: QualityMode, b: QualityMode) {
  return QUALITY_MODE_NUMBER_MAP[a] - QUALITY_MODE_NUMBER_MAP[b];
}

/**
 * Returns the maximum size of a data track message in bytes. Defaults to 0
 * (falsey) i.e. no max size.
 *
 * This is necessary because large messages can crash data track functionality.
 * https://www.twilio.com/docs/video/using-datatrack-api#overview
 */
export function getMaxDataChannelMessageSizeBytes() {
  const maxMessageSizeBytes = Statsig.getDynamicConfig(dynamicConfig)?.get(
    "max_data_track_message_size_bytes",
    0,
  );
  return maxMessageSizeBytes >= 0 ? maxMessageSizeBytes : 0; // handles negatives just in case
}

export function getStoredBackgroundSettings(): BackgroundSettings {
  const { backgroundType, backgroundIndex } = getStoredAudioVideoSettings();
  return { backgroundType, backgroundIndex };
}
